import { render, staticRenderFns } from "./ApprovalWorkflow.vue?vue&type=template&id=69c80575&scoped=true"
import script from "./ApprovalWorkflow.vue?vue&type=script&lang=js"
export * from "./ApprovalWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c80575",
  null
  
)

export default component.exports